//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BankLookupSectionEmbed from '~/components/sections/BankLookupSectionEmbed.vue';
import BankLookupSectionEmbedV2 from '~/components/sections/BankLookupSectionEmbedV2.vue';
export default {
  name: 'BankLookupIframe',
  components: {
    BankLookupSectionEmbed,
    BankLookupSectionEmbedV2
  },
  layout: 'empty',

  data() {
    return {
      history: [],
      query: '',
      result: null,
      disableCriteo: false
    };
  },

  publicRuntimeConfig: {
    disableIntercom: true,
    disableCriteo: true,
    reportETL: false
  },

  beforeCreate() {
    this.$config.disableIntercom = true;
    this.$config.disableCriteo = true;
    this.$config.reportETL = false;
  },

  mounted() {
    if (window.Intercom) {
      this.$intercom.shutdown();
    }
  },

  methods: {
    onRedirect(link) {
      window.open(link, '_blank');
    }

  }
};